//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Verificaciones from '@/api/promotores/usuarios/verificaciones.api'
import Modulos from '@/api/promotores/usuarios/modulos.api'

export default {
  data() {
    return {
      verificaciones: [],
      loading: false,
    };
  },

  mounted() {
    this.loadVerificaciones();
  },

  methods: {
    async loadVerificaciones() {
      try {
        this.loading = true;
        this.verificaciones = await Verificaciones.all(this.$route.params.promotor);
        console.log(this.verificaciones)
      } finally {
        this.loading = false;
      }
    },
    openMatiDashboardUrl(e, verificacion) {
      window.open(verificacion.matiDashboardUrl, "_blank");
    },
    getStatusLabel(identity) {
      return identity ? identity.status : null;
    },
    getStatusColor(identity) {
      const status = identity ? identity.status : null;

      return {
        verified: "green-8",
        reviewNeeded: "yellow-9",
      }[status];
    },
    async deleteVerificacion(verificacion) {
      this.$q.dialog({
        title: `Eliminar verificación`,
        message: `¿Estas seguro que quieres eliminar la verificación ${verificacion._id}?.
                      <br><b class="text-negative">Esta acción no podra deshacerse.</b>`,
        cancel: true,
        html: true,
        dark: true,
        ok: { color: 'negative', flat: true }
      }).onOk(async () => {
        try {
          await Verificaciones.delete(this.$route.params.promotor, verificacion._id)
          this.loadVerificaciones()
        } catch (e) {
          console.error(e);
        }
      })
    },

    solicitarVerificacion() {
      this.$q
        .dialog({
          title: "Desactivar modulo",
          message: `¿Seguro que quieres solicitar al promotor que realice una nueva verificación?`,
          html: true,
          cancel: true,
        })
        .onOk(async () => {
          await Modulos.delete(this.$route.params.promotor, 'mati')
          this.loadVerificaciones()
        })
    },

    verificar() {
      this.$q
        .dialog({
          title: "Verificación manual",
          message: `¿Seguro que quieres verificar al promotor?`,
          html: true,
          cancel: true,
        })
        .onOk(async () => {
          await Modulos.resolve(this.$route.params.promotor, 'mati')
          window.location.reload();
        })
    }
  },
};
